// extracted by mini-css-extract-plugin
export default {"input":"DiscountInput_input__2cTYS","selectInput":"DiscountInput_selectInput__BskYE"};